import { CodeBase } from "./_codeBase";

/** メール送信頻度区分*/
export class MailSendFrequencyDiv extends CodeBase<MailSendFrequencyDiv>
{
    /** メール送信頻度区分: "01", "即時", ""*/
    public static readonly IMMEDIATE: MailSendFrequencyDiv = new MailSendFrequencyDiv("01", "即時", "");
    /** メール送信頻度区分: "02", "n回/日" ""*/
    public static readonly PER_DAY: MailSendFrequencyDiv = new MailSendFrequencyDiv("02", "n回/日", "");
    /** メール送信頻度区分: "03", "n分間隔", ""*/
    public static readonly MIN_INTERVAL: MailSendFrequencyDiv = new MailSendFrequencyDiv("03", "n分間隔", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): MailSendFrequencyDiv[] {
        return [
            MailSendFrequencyDiv.IMMEDIATE,
            MailSendFrequencyDiv.PER_DAY,
            MailSendFrequencyDiv.MIN_INTERVAL,

        ];
    }
}
